import { getActiveOrFirstUserId } from './assignedUsers';
import { isSharedLead } from './isSharedLead';
import type { LeadAssignment } from './leadAssignment';

// shared non-IK lead: the user next to the owner; canonical (read-model addedAssignedUser is bell metadata only)
export const getAddedAdvisorId = (lead: LeadAssignment) => {
    if (!isSharedLead(lead)) return null;
    const ownerId = getActiveOrFirstUserId(lead);
    return lead.userIds.find((userId) => userId !== ownerId) ?? null;
};
